export function ExecutionStatus({ status }) {
  const statusConfig = {
    pending: {
      bg: 'bg-gray-100',
      text: 'text-gray-800',
      label: 'Pending'
    },
    running: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      label: 'Running'
    },
    completed: {
      bg: 'bg-green-100',
      text: 'text-green-800',
      label: 'Completed'
    },
    failed: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      label: 'Failed'
    }
  }

  const config = statusConfig[status] || statusConfig.pending

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  )
}
